const get = require('lodash/get')
const { listProductsForPrograms } = require('./list-for-programs-services')
const {
  construct,
  buildServiceColumns,
  buildWarehouseServiceColumns,
  injectWarehouseColumns,
  getServiceIdsFromConfigurationDocs
} = require('./../../tools')
const removeRev = require('./../../../utils/remove-rev')
const utils = require('./../../utils')

exports.exportProducts = async (state, opts = {}) => {
  const userPrograms = get(state, 'user.programs', [])
  const serviceProducts = await listProductsForPrograms(state, userPrograms)
  const products = opts.template
    ? serviceProducts.concat(await listGenericChildrenOutside(state, serviceProducts))
    : serviceProducts
  const serviceConfigurations = await getServiceConfigurationsForPrograms(state, userPrograms)
  const serviceIds = getServiceIdsFromConfigurationDocs(serviceConfigurations)
  const serviceColumns = buildServiceColumns(serviceIds)
  const warehouseColumns = buildWarehouseServiceColumns(serviceConfigurations)
  const additionalColumns = Object.assign(
    {},
    get(opts, 'additionalColumns', {}),
    injectWarehouseColumns(serviceColumns, warehouseColumns)
  )
  return utils.sheet.encode(products, Object.assign({}, opts, { additionalColumns }))
}

// Get products whose generic parents are on service,
// excluding those already in `products`
async function listGenericChildrenOutside (state, products) {
  const now = new Date().toISOString()
  const productIds = new Set(products.map(product => product._id))
  const genericCodes = products.map(product => product._id.replace('product:', ''))
  const children = await state.dal.product.getByGenericParent(state, genericCodes)
  return children
    .filter(doc => doc._id.startsWith('product:') && !productIds.has(doc._id))
    .map(doc => removeRev(construct(doc, { now })))
}

async function getServiceConfigurationsForPrograms (state, programIds) {
  const serviceConfigurationsByProgram = await Promise.all(
    (programIds || []).map(programId => state.dal.product.getProgramConfiguration(state, programId))
  )
  return serviceConfigurationsByProgram.reduce((acc, docs) => acc.concat(docs), [])
}

exports.getServiceConfigurationsForPrograms = getServiceConfigurationsForPrograms
